module.exports = __webpack_public_path__ + "static/professionalism-cae6dd04ae54be06386ee00e9753016e.jpg";